import React from 'react'
import { Route, Switch } from 'react-router'
import InvoicingOrders from './InvoicingOrders'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={InvoicingOrders} />
    </Switch>
)

export default Components
